export default __webpack_public_path__ + "images/969d2459b765810ef7024b996ee4eb55-nye_homepage_banner_tablet.webp";